import moment from 'moment';

export default function getCurrentTimeZoneTime(dateTime) {
  const splitTimeString = dateTime.toLocaleString('en-US').split(' ');
  const time = splitTimeString.slice(0, 3).join(' ');
  return moment(time).format('MMMM Do YYYY, HH:mm');
}
